import PhotoGallery from 'shared/components/PhotoGallery'
import 'react-image-lightbox/style.css'
import './index.scss'

export default PhotoGallery
